module.exports = __webpack_public_path__ + "media/images/jumping/promo-hero-section-594c9ee0129c44d78e9ad2bcedc49df4.jpg";